import { User } from './user';
import { AccountUpdateType } from './enums/accountUpdateType';
export class AccountUpdateRequest
{
    updateType: AccountUpdateType;
    user: User;
}